// 연락처
export const formatPhoneNumber = (value) => {
    value = value.replace(/[^0-9]/g, "");
    return value.replace(
        /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
        "$1-$2-$3"
    );
};
// 생년월일
export const formatBirthDate = (value) => {
    // 숫자 이외의 문자는 제거
    value = value.replace(/[^0-9]/g, "");

    // YYYY.MM.DD 형식으로 포맷팅
    if (value.length <= 4) {
        return value;
    } else if (value.length <= 6) {
        return `${value.slice(0, 4)}.${value.slice(4)}`;
    } else {
        return `${value.slice(0, 4)}.${value.slice(4, 6)}.${value.slice(6, 8)}`;
    }
};
